/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useMemo, useState} from 'react';
import Box from '@material-ui/core/Box';
import {makeStyles, withStyles, Tab, Tabs, useTheme, useMediaQuery} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import {useDispatch, useSelector} from 'react-redux';
import WrapperContainerFields from '../../components/WrapperContainerFields';
import {Form, Formik} from 'formik';
import * as yup from 'yup';
import api from '../../services/api';
import {addNotification} from '../../redux/actions';
import {SELECTOR_USER} from '../../redux/selectors/auth';
import Text from '../../components/fields/Text';
import BusinessUsers from './BusinessUsers';
import CompaniesBudgets from './CompaniesBudgets';
import {Route, useHistory, Switch, matchPath, useLocation} from 'react-router-dom';

function TabPanel(props) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useTabStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: 224,
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    [theme.breakpoints.up('sm')]: {
      borderBottom: 0,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
  },
}));

const CustomTab = withStyles((theme) => ({
  root: {
    textAlign: 'start',
    backgroundColor: theme.palette.common.white,
    textTransform: 'uppercase',
  },
}))(Tab);

const validationCompanyDataSchema = yup.object().shape({
  nit: yup.string().required('NIt es requerido.'),
  name: yup.string().required('Nombre es requerido.'),
});

const BusinessV2 = () => {
  const [companyInitialValues, setCompanyInitialValues] = useState({});
  const [value, setValue] = useState(0);
  const [companyId, setCompanyId] = useState(null);

  const session = useSelector(SELECTOR_USER);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const history = useHistory();
  const location = useLocation();

  const theme = useTheme();
  const isMobil = useMediaQuery('(max-width: 768px)');

  const classes = useTabStyles();

  const tabs = useMemo(
    () => [
      {
        title: 'Usuarios',
        path: ['/mi-cuenta/empresa', '/mi-cuenta/empresa/usuarios'],
        component: BusinessUsers,
      },
      {
        title: 'Presupuestos',
        path: ['/mi-cuenta/empresa/presupuestos'],
        component: CompaniesBudgets,
      },
    ],
    [],
  );

  const getCurrentUser = async () => {
    const {data} = await api.users.find();
    setCompanyInitialValues({
      name: data[0]?.company?.name,
      nit: data[0]?.company?.nit,
    });
    setCompanyId(data[0]?.company?.id);
  };

  const handleChange = (_, newValue) => {
    const tabPath = tabs[newValue].path;
    const newPath = Array.isArray(tabPath) ? tabPath[0] : tabPath;
    history.push(newPath);
    setValue(newValue);
  };

  const saveCompanyData = async ({name, nit}) => {
    try {
      await api.companies.patch(companyId, {nit, name});
      await getCurrentUser();
      dispatch(addNotification('Datos actualizados con exito.', 'info'));
    } catch (e) {
      dispatch(addNotification(e.message, 'error'));
    }
  };

  const matchUrl = (p1, p2) => !!matchPath(p1, {path: p2, exact: true});
  useEffect(() => {
    const index = tabs.findIndex((it) => {
      const path = it.path;
      const isArray = Array.isArray(path);
      if (isArray) {
        return !!path.filter((p) => !!matchUrl(location.pathname, p)).length;
      } else {
        return !!matchUrl(location.pathname, path);
      }
    });
    setValue(index);
  }, [location.pathname, tabs.length]);

  useEffect(() => {
    setCompanyInitialValues({
      name: user?.company?.name,
      nit: user?.company?.nit,
    });
    setCompanyId(user?.company?.id);
  }, [user?.id, user?.company?.id]);

  return (
    <Box>
      <Formik
        enableReinitialize={true}
        initialValues={companyInitialValues}
        validationSchema={validationCompanyDataSchema}
        onSubmit={saveCompanyData}
        render={({values, handleChange, handleSubmit}) => (
          <Form
            onKeyPress={(event) => {
              event.key === 'Enter' && handleSubmit();
            }}
          >
            <WrapperContainerFields>
              <Grid item xs={12} md={4}>
                <Text disabled name={'name'} label="Nombre de la empresa" value={values.name} onChange={handleChange} />
              </Grid>
              <Grid item xs={12} md={4}>
                <Text
                  disabled
                  name={'nit'}
                  label="Documento de la empresa"
                  value={values.nit}
                  onChange={handleChange}
                />
              </Grid>
            </WrapperContainerFields>
          </Form>
        )}
      />
      {session.owner_company === 'true' && (
        <Grid container>
          <Grid item xs={12} sm={2}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              orientation={isMobil ? 'horizontal' : 'vertical'}
              className={classes.tabs}
              textColor="inherit"
              variant="fullWidth"
              scrollButtons="auto"
            >
              {tabs.map((tab, i) => (
                <CustomTab key={i} label={tab.title} {...a11yProps(i)} />
              ))}
            </Tabs>
          </Grid>
          <Grid item xs={12} sm={10}>
            <Switch>
              {tabs.map((tab, i) => (
                <Route
                  exact
                  key={i}
                  path={tab.path}
                  component={() => (
                    <TabPanel index={i} value={i} dir={theme.direction}>
                      {React.createElement(tab.component, {})}
                    </TabPanel>
                  )}
                />
              ))}
            </Switch>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default BusinessV2;
